import { createComponent } from "react-fela";

export const icons = {
    "menu-arrow": {
        maskImage: "url('/icons/left-filled-arrow-triangle.svg')",
        transform: "rotate(-90deg)",
        width: 7,
        height: 7
    },
    "pagination-arrow": {
        maskImage: "url('/icons/right-arrow.svg')",
        width: 10,
        height: 18
    },
    "pagination-button": {
        maskImage: "url('/icons/right-pagination-next.svg')",
        width: 52,
        height: 38
    },
    close: {
        maskImage: "url('/icons/close.svg')",
        width: 24,
        height: 24
    },
    "menu-arrow-full": {
        maskImage: "url('/icons/left-filled-arrow-triangle.svg')",
        transform: "rotate(-90deg)",
        width: 7,
        height: 7
    }
};

export default createComponent(
    ({ name, styles, flipped }) => ({
        display: "inline-block",
        backgroundColor: "currentColor",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        transition: "transform 250ms",
        verticalAlign: "middle",
        ...icons[name],
        extend: [
            {
                condition: flipped,
                style: {
                    transform: "scaleX(-1)"
                }
            }
        ],
        ...styles
    }),
    "span"
);
